import { useMemo } from 'react'
import { Table } from '@components/Table'
import { CardContainer } from '@features/dashboard/pages/WriterPublisherPage/components/Container'
import { NoData } from '@components/NoData'
import { columns } from './column'
import { ChapterListProps } from './interface'

export function ChapterList({
  data,
  isLoading,
  sort,
  handleSort,
  handleFetchNextPage,
}: ChapterListProps) {
  const bookChapterDetail = useMemo(
    () =>
      data?.pages
        .map(page => page.data)
        .reduce((prev, curr) => prev.concat(curr), []) || [],
    [data]
  )
  return (
    <>
      <CardContainer>
        <h1 className='font-mitr text-2xl font-medium text-secondary mb-5'>
          รายละเอียด Buy Chapter
        </h1>

        <Table
          onSort={handleSort}
          onWaypointEnter={handleFetchNextPage}
          className='mb-[30px] max-h-[400px]'
          fixedHeader
          isLoading={isLoading}
          data={bookChapterDetail}
          columns={columns}
          initialSort={{ key: sort.key, order: sort.order }}
        />
      </CardContainer>
    </>
  )
}
